import { render } from "./SwitchButton.vue?vue&type=template&id=fdd41d8a&scoped=true"
import script from "./SwitchButton.vue?vue&type=script&lang=js"
export * from "./SwitchButton.vue?vue&type=script&lang=js"

import "./SwitchButton.vue?vue&type=style&index=0&id=fdd41d8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdd41d8a"]])

export default __exports__